import styled, { css } from 'styled-components';

export const NewPermissionArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  >div {
    flex-grow: 1;
    flex-basis: 0;
  }

  @media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
    flex-direction: column;
    >div {
      flex-grow: 1;
      flex-basis: unset;
    }
  }
`;

export const CheckBoxManadatory = styled.div`
  flex-grow: 0 !important;
  flex-basis: 0;
`;

export const AreaButton = styled.div`
  margin-top: 5px;
  >button {
    margin-left: 0px;
    margin-right: 1rem;
  }
`;

interface IContainerCopmanySelectProps {
  $isNullUndefinedValue: boolean;
}
export const ContainerCopmanySelect = styled.div<IContainerCopmanySelectProps>`
  position: relative;
  width: 100%;

  ${({ $isNullUndefinedValue }) =>
    $isNullUndefinedValue &&
    css`
      .MuiInputBase-root.MuiInputBase-formControl {
        padding-right: 140px !important;
      }
      .ClearableIcon {
        display: none;
        color: ${({ theme }) => theme.pantone2726C};
      }

      &:hover {
        .ClearableIcon {
          display: block;
        }
      }
    `}
`;

export const AreaCheckboxAllCopmanies = styled.div`
  position: absolute;
  display: flex;
  top: 12px;
  right: 40px;
  margin: 0;
  justify-content: center;
  align-items: center;

  .MuiFormControlLabel-root {
    margin: 0;
  }

  .MuiCheckbox-root {
    padding: 0;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: #fab01c;
  }
`;

